module.exports = __webpack_public_path__ + "media/images/instruction/step-one-94f921f0dd4d6b1ab722e7d0fcf46d71.svg";